"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radius = void 0;
var Radius;
(function (Radius) {
    Radius["Zero"] = "0";
    Radius["XXS"] = "4px";
    Radius["XS"] = "6px";
    Radius["S"] = "8px";
    Radius["M"] = "16px";
    Radius["L"] = "24px";
    Radius["XL"] = "32px";
    Radius["XXL"] = "40px";
    Radius["Rounded"] = "666px";
})(Radius || (exports.Radius = Radius = {}));
//# sourceMappingURL=Radius.js.map